/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate percent (w/v) concentration: %(w/v) = mass in grams ÷ volume in mL × 100.`)
};

const es_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la concentración porcentual (p/v): %(p/v) = masa en gramos ÷ volumen en mL × 100.`)
};

const de_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie die Prozentkonzentration (w/v): %(w/v) = Masse in Gramm ÷ Volumen in mL × 100.`)
};

const nl_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de procentuele (g/v) concentratie: %(g/v) = massa in gram ÷ volume in mL × 100.`)
};

const fr_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la concentration en pourcentage (p/v) : %(p/v) = masse en grammes ÷ volume en mL × 100.`)
};

const it_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la concentrazione percentuale (p/v): %(p/v) = massa in grammi ÷ volume in mL × 100.`)
};

const pt_br2_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a concentração percentual (p/v): %(p/v) = massa em gramas ÷ volume em mL × 100.`)
};

const pt_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a concentração percentual (m/v): %(m/v) = massa em gramas ÷ volume em mL × 100.`)
};

const ja_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント (w/v) 濃度を計算します: %(w/v) = 質量(g) ÷ 体積(mL) × 100。`)
};

const zh_pctsol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算百分比（w/v）浓度：%(w/v) = 质量（克）÷ 体积（mL）× 100。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_tool_description", locale)
	if (locale === "en") return en_pctsol_tool_description(inputs)
	if (locale === "es") return es_pctsol_tool_description(inputs)
	if (locale === "de") return de_pctsol_tool_description(inputs)
	if (locale === "nl") return nl_pctsol_tool_description(inputs)
	if (locale === "fr") return fr_pctsol_tool_description(inputs)
	if (locale === "it") return it_pctsol_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_tool_description(inputs)
	if (locale === "pt") return pt_pctsol_tool_description(inputs)
	if (locale === "ja") return ja_pctsol_tool_description(inputs)
	return zh_pctsol_tool_description(inputs)
};